// icons
import { Close } from "../../../SVGS";
// styles
import styled from "styled-components";

const SpecialDayItemStyles = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-radius: ${({ theme }) => theme.radius[12]};
  padding: ${({ theme }) => theme.spacing[16]};
  background: ${({ theme }) => theme.colors.semantic.container.white};
  border: 1px solid ${({ theme }) => theme.colors.semantic.outline.default};
  .content {
    display: flex;
    flex-direction: column;
    gap: 4px;

    .name {
      font-weight: ${({ theme }) => theme.typography.title.t2.weight};
      font-size: ${({ theme }) => theme.typography.body.b2.size};
      line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
      letter-spacing: 0.1px;
      color: ${({ theme }) => theme.colors.semantic.text.strong};
      margin: 0;
    }

    .date {
      font-weight: normal;
      font-size: ${({ theme }) => theme.typography.body.b2.size};
      line-height: ${({ theme }) => theme.typography.body.b2.lineHeight};
      letter-spacing: 0.1px;
      color: ${({ theme }) => theme.colors.semantic.text.weak};
      margin: 0;
    }
  }
`;

const SpecialDayItem = ({ dayName, date, removeAction }) => {
  return (
    <SpecialDayItemStyles>
      <div className="content">
        <h3 className="name">{dayName}</h3>
        <p className="date">{date}</p>
      </div>
      <Close onClick={removeAction} />
    </SpecialDayItemStyles>
  );
};

export default SpecialDayItem;
